import { toast } from 'react-toastify';

const countrySelect = document.querySelector('[name="country_code"]')
const locale = document.querySelector('.trade-in-proposal')?.getAttribute('data-locale')
const accountTypeSelect = document.querySelector('[name="00N09000005KXH5"]')
const ebikeBrandSelect = document.querySelector('[name="00NQu000000h83y"]')

// Phonenumber
const mobile = document.getElementById('mobile');

// Gender <-> Salutation
const genderSelect = document.querySelector('[name="00N09000005KXHJ"]')
const salutationSelect = document.querySelector('[name="salutation"]')

// 00N7Z00000AyVJE
const productTypeSelect = document.querySelector('[name="00NQu000000h83z"]')
const ageSelect = document.querySelector('[name="00NQu000000h840"]')

// form element
const formEl = document.querySelector('[name="trade-in"]')

// Additional fields
const postalCodeInput = document.getElementById('zip')
const houseNumberInput = document.getElementById('00N09000005KXHK')

const productTypeAge = {
    'Niet elektrisch': ['', '0 - 2 jaar', '2 - 6 jaar', 'ouder dan 6 jaar'],
    'E-bike ander merk': ['', '0 - 1 jaar', '1 - 2 jaar', '2 - 4 jaar', '4 - 7 jaar', 'ouder dan 7 jaar'],
    'Stella e-bike': ['', '0-1 jaar', '1-3 jaar', '3-5 jaar', 'ouder dan 5 jaar'],
}

document.addEventListener("DOMContentLoaded", (event) => {
    // Set phonenumber prefix by locale
    if (mobile) {
        const nlPattern = '^00316\\d{8}$';
        const bePattern = '^0032[1-9]\\d{5,9}$';

        mobile.setAttribute('data-parsley-pattern', locale === 'nl_be' ? bePattern : nlPattern);
        mobile.setAttribute('data-parsley-required', 'true');

        mobile.value = locale === 'nl_be' ? '0032' : '0031';
    }

    // Set country by Sulu locale
    if (countrySelect && locale)
        countrySelect.value = locale === 'nl_be' ? 'BE' : locale.toUpperCase()

    // Only execute if form (templates/app/salesforce_forms/trade-in.html) exists on page
    if (formEl) {
        const formTypeSelect = formEl.querySelector('[name="00N09000005KXHh"]')

        // Set salutation by gender
        if (genderSelect && salutationSelect)
            genderSelect.addEventListener('change', (event) => {
                event.target.value === 'M' ? salutationSelect.value = 'Mr.' : salutationSelect.value = 'Ms.';
            })

        // Set form type
        if (formTypeSelect)
            formTypeSelect.value = 'Inruilformulier';

        // Set account type
        if (accountTypeSelect)
            accountTypeSelect.value = 'Household';

        // Filter select options by product type
        if (productTypeSelect && ageSelect) {
            // All items hidden on page load
            Array.from(ageSelect.options).forEach((option) => {
                option.style.display = 'none'
            })

            productTypeSelect.addEventListener('change', (event) => {
                const value = event.target.value;
                const visibleAges = productTypeAge[value];
                if (visibleAges)
                    Array.from(ageSelect.options).forEach((option) => {
                        !visibleAges.includes(option.value) ? option.style.display = 'none' : option.style.display = 'block'
                    })

                // Reset select
                ageSelect.value = '';

                // Show/hide e-bike brands
                if (value === 'E-bike ander merk' && ebikeBrandSelect)
                    ebikeBrandSelect.parentElement.style.cssText = 'display: block !important'
                else
                    ebikeBrandSelect.parentElement.style.cssText = 'display: none !important'
            })
        }

        const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func.apply(null, args);
                }, delay);
            };
        };

        const fetchAddress = async (postalCode, houseNumber) => {
            try {
                const response = await fetch(`/get-address`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        postalCode: postalCode,
                        addressNumber: houseNumber
                    })
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data.address) {
                        const streetInput = document.querySelector('#street');
                        const cityInput = document.querySelector('#city');
                        if (streetInput) streetInput.value = data.address.street;
                        if (cityInput) cityInput.value = data.address.city;
                    }
                } else {
                    toast.error("Er is geen adres gevonden voor deze postcode en huisnummer.");
                }
            } catch (error) {
                toast.error('Er is iets fout gegaan bij het ophalen van de adres.');
            }
        };

        const checkAddress = debounce(() => {
            const postalCode = postalCodeInput.value.trim();
            const houseNumber = houseNumberInput.value.trim();

            if (postalCode && houseNumber) {
                fetchAddress(postalCode, houseNumber);
            }
        }, 500);

        if (locale === 'nl') {
            postalCodeInput.addEventListener('input', checkAddress);
            houseNumberInput.addEventListener('input', checkAddress);
        }
    }
});
